import { Star, StarHalf } from '@phosphor-icons/react';

const SIZE_MAP = { sm: 'w-4 h-4', md: 'w-5 h-5', lg: 'w-6 h-6' };
const INTERACTIVE_SIZE_MAP = { sm: 'w-5 h-5', md: 'w-6 h-6', lg: 'w-8 h-8' };

export function StarRating({ rating, size = 'sm', showCount = false, count = 0 }) {
  const starSize = SIZE_MAP[size] || SIZE_MAP.sm;
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 >= 0.5;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

  return (
    <div className="flex items-center gap-1">
      <div className="star-rating">
        {[...Array(fullStars)].map((_, i) => (
          <Star key={`full-${i}`} weight="fill" className={`star ${starSize}`} />
        ))}
        {hasHalfStar && <StarHalf weight="fill" className={`star ${starSize}`} />}
        {[...Array(emptyStars)].map((_, i) => (
          <Star key={`empty-${i}`} weight="regular" className={`star empty ${starSize}`} />
        ))}
      </div>
      {showCount && (
        <span className="text-sm text-muted-foreground">({count})</span>
      )}
    </div>
  );
}

export function InteractiveStarRating({ value, onChange, size = 'md' }) {
  const starSize = INTERACTIVE_SIZE_MAP[size] || INTERACTIVE_SIZE_MAP.md;

  return (
    <div className="flex gap-1">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          onClick={() => onChange(star)}
          className="transition-transform hover:scale-110 focus:outline-none"
          data-testid={`star-${star}`}
        >
          <Star
            weight={star <= value ? 'fill' : 'regular'}
            className={`${starSize} ${star <= value ? 'text-accent' : 'text-muted'}`}
          />
        </button>
      ))}
    </div>
  );
}
